import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchPendingNotification } from '../../redux/slices/PendingPricingSlice';
import TabMenus from '../../shared-components/tab-menus/TabMenus';

import ApprovedPricing from './components/ApprovedPricing';
import PendingPricing from './components/PendingPricing';
import RejectedPricing from './components/RejectedPricing';

/**
 * Dynamic pricing compo
 */
function DynamicPricing() {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation('pricing');
  const { pendingNotificationCount } = useAppSelector((state) => state.pendingPricing);
  const { currentPage } = useParams<{ currentPage: string }>();
  const [openTab, setOpenTab] = useState<number>(0);

  /**
   * Handle the tab change function
   * @param {any} number - The number
   */
  const changePageHandle = (number: number) => {
    setOpenTab(number);
    let pageName = '';
    switch (number) {
      case 0:
        pageName = 'approved';
        break;
      case 1:
        pageName = 'unapproved';
        break;
      case 2:
        pageName = 'rejected';
        break;

      default:
        break;
    }
    window.history.pushState({}, '', `${pageName}`);
  };

  useEffect(() => {
    if (currentPage) {
      let number = 0;
      switch (currentPage) {
        case 'approved':
          number = 0;
          break;
        case 'unapproved':
          number = 1;
          break;
        case 'rejected':
          number = 2;
          break;

        default:
          break;
      }
      setOpenTab(number);
    }
  }, []);
  useEffect(() => {
    dispatch(fetchPendingNotification());
  }, []);
  return (
    <div className="dynamic-pricing-wrap" dir={i18n.dir()}>
      <div className="dynamic-pricing-toggle">
        <TabMenus
          openTab={openTab}
          setOpenTab={changePageHandle}
          menus={[
            {
              name: t('approved'),
            },
            {
              name: t('pending'),
              count: pendingNotificationCount,
            },
            {
              name: t('rejected'),
            },
          ]}
        />
      </div>
      <div className="table-container">
        {(() => {
          let dynamicPricingTable;
          if (openTab === 0) {
            dynamicPricingTable = <ApprovedPricing />;
          } else if (openTab === 1) {
            dynamicPricingTable = <PendingPricing />;
          } else if (openTab === 2) {
            dynamicPricingTable = <RejectedPricing />;
          }
          return dynamicPricingTable;
        })()}
      </div>
    </div>
  );
}

export default DynamicPricing;
